const namespace = '[ENTITY_LOCATIONS]';

export const FETCH_LOCATIONS = `${namespace} FETCH_LOCATIONS`;
export const SET_LOCATIONS = `${namespace} SET_LOCATIONS`;
